import { render, staticRenderFns } from "./LandingSafeguardsItem.html?vue&type=template&id=396bd4aa&scoped=true&"
import script from "./LandingSafeguardsItem.ts?vue&type=script&lang=ts&"
export * from "./LandingSafeguardsItem.ts?vue&type=script&lang=ts&"
import style0 from "./LandingSafeguardsItem.scss?vue&type=style&index=0&id=396bd4aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396bd4aa",
  null
  
)

export default component.exports